import { useNavigate } from "react-router-dom";
import { Hero, HeroImage } from "../../../assets/services";
import { toast } from "react-toastify";

export default function SectionOne()
{
    const navigate=useNavigate();
    const handleBookService = () => {
        const storedUser = localStorage.getItem("customeruser");
      
        if (storedUser) {
            navigate("/bookservice");
        } else {
            toast.warning("Please login to continue");
            setTimeout(() => navigate("/login"), 1000);
            return;
        }
    };
    return(
        <section
            className="py-5 bg-cover bg-center h-80 xl:h-96 grid grid-cols-1 md:grid-cols-2 items-center w-full"
            style={{ backgroundImage: `url(${HeroImage})` }}
        >

        <div className="flex flex-col space-y-3 justify-center items-center text-center font-bold md:max-w-sm xl:max-w-md">
            <p className="text-2xl xl:text-3xl pl-5">We are offering services to dealer in <span className="text-red-900 font-bold">lower </span> prices than consumer</p>     
            <button className="px-3 py-1 bg-[#A63F40] rounded-xl text-white w-44 text-xs md:text-sm xl:text-base" onClick={handleBookService}>Book Service Now</button>         
        </div>

        <div className="hidden md:flex">
          <img src={Hero} className="w-full h-full"/>
        </div>
        </section>

    );
}